import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme, hovered }) => ({
  height: '30px',
  background: theme.color.controlsMenuBgColor,
  borderRadius: theme.radius.small,
  position: 'absolute',
  top: '-110px',
  left: '-68px',
  transform: 'scale(0) rotate(-90deg)',
  transition: '150ms all',

  extend: {
    condition: hovered,
    style: {
      transform: 'scale(1) rotate(-90deg)',
    },
  },
});

const VolumeSlider = ({ hovered, children }) => {
  const { css } = useFela({ hovered });

  return (
    <div className={css(rules)} data-cy="hp-volume-slider">
      {children}
    </div>
  );
};

VolumeSlider.propTypes = {
  hovered: PropTypes.bool,
  children: PropTypes.node,
};

export default React.memo(VolumeSlider);
